import type { CSSProperties } from '@actual-app/components/styles';

import { CellValue, CellValueText } from '#components/spreadsheet/CellValue';
import type { FormatType } from '#hooks/useFormat';
import type { Binding, SheetFields } from '#spreadsheet';

type SidebarBalanceProps<FieldName extends SheetFields<'account'>> = {
  binding: Binding<'account', FieldName>;
  style?: CSSProperties;
  testId?: string;
  /** currency whose symbol the value is shown with (default: budget) */
  currency?: string;
  formatter?: (value: unknown, type?: FormatType) => string;
  title?: string;
};

export function SidebarBalance<FieldName extends SheetFields<'account'>>({
  binding,
  style,
  testId,
  currency,
  formatter,
  title,
}: SidebarBalanceProps<FieldName>) {
  return (
    <CellValue<'account', FieldName> binding={binding} type="financial">
      {props => (
        <CellValueText<'account', FieldName>
          {...props}
          currency={currency}
          formatter={formatter}
          title={title}
          data-testid={testId ?? props.name}
          style={{ textAlign: 'right', ...style }}
        />
      )}
    </CellValue>
  );
}
